import React, {Fragment} from 'react'
import {Route} from 'react-router'
import {Journal} from '../Journal'
import {Article} from '../Article'
import {News} from '../News'
import {FourOhFour} from 'features/pages/FourOhFour'

// 1058528 is kpr's journal alter ego
export const JOURNAL_USERID = process.env.NODE_ENV === 'production'
  ? 1058528
  : 1
// 1058510 is kpr's news alter ego
export const NEWS_USERID = process.env.NODE_ENV === 'production'
  ? 1058510
  : 1

const currentUserIsAdmin = window.rwgps &&
  window.rwgps.config &&
  window.rwgps.config.currentUser &&
  window.rwgps.config.currentUser.account_level === 11

export const routes = (
  <Fragment>
    <Route path='/journal' component={Journal} />
    <Route path='/journal/:slug' component={Article} />
    <Route path='/news' component={currentUserIsAdmin ? News : FourOhFour} />
    <Route path='/news/:slug' component={currentUserIsAdmin ? Article : FourOhFour} />
  </Fragment>
)
